import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import { Checkbox } from '@/components/ui/Form/Checkbox';
/**
 * 「提案予定のチームを選択」のチェックボックス
 * @param props
 * @constructor
 */
export const RfpClientOneFileAllFormCheckboxProposalToDo = (props) => {
    const { change, changeName, className, disabled, label, proposalToDoValuesIds, values = [], } = props;
    const checked = useMemo(() => proposalToDoValuesIds.length > 0 &&
        proposalToDoValuesIds.every((val) => values.includes(val)), [proposalToDoValuesIds, values]);
    /**
     * 選択／解除を実行
     */
    const onChange = useCallback(() => {
        let updateValues = [];
        if (checked) {
            // 提案予定の閲覧申請だけ選択解除する
            updateValues = values.filter((value) => !proposalToDoValuesIds.includes(value));
        }
        else {
            // 提案予定の閲覧申請を追加で選択する
            updateValues = [...new Set([...values, ...proposalToDoValuesIds])].sort();
        }
        // form の値更新
        change(changeName, updateValues);
    }, [checked, change, changeName, proposalToDoValuesIds, values]);
    return (_jsx(Checkbox, { checked: checked, className: className, disabled: disabled, label: label, onChange: onChange }));
};
